export const connectToChainId = 1;
export const mainnetChainIdRPC = "https://mainnet.infura.io/v3/541e6a12a18f482e94c043f2d899a314";
export const testnetChainIdRPC = "https://kovan.infura.io/v3/541e6a12a18f482e94c043f2d899a314";
